import { Injectable } from '@angular/core';
import { TemplateArea } from './document-template-administration-model';

@Injectable({
  providedIn: 'root'
})
export class DocumentTemplateEditorService {

  constructor() { }

  public updateAreaAfterChanges(area: TemplateArea) {

    // sortieren nach row und colum
    area.fields.sort((a, b) => {
      if (a.row === b.row) {
        return a.column - b.column;
      }
      return a.row - b.row;
    });

    // Zeilen normalisieren
    let currentRow = 0;
    let lastRow = null;
    for (const field of area.fields) {

      if (field.row !== lastRow) {
        lastRow = field.row;
        currentRow = currentRow + 1;
      }

      field.row = currentRow;
    }

    // styles aktualisieren
    area.fields.forEach(f => f.style = {
      'grid-row': f.row * 2, 'grid-column': f.column + ' / span ' + f.colSpan
    });

    let totalRowCount = 0;
    for (const field of area.fields) {
      if (totalRowCount < field.row) {
        totalRowCount = field.row;
      }
    }
    area.rowCount = totalRowCount;
  }

}
